import { Link, Typography } from '@one-thd/sui-atomic-components';
import { DateTime } from 'luxon';
import React, { Fragment, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { useExperienceContext } from '../../../hooks/useContexts';
import { getDisplayHeader } from '../../../utils/order-details/OrderDetailsUtils';
import { getQuantityByStatus } from '../../../utils/order-details/LineItemUtils';
// TODO: Temporary B2C Online Receipt View. Remove when backend creates image 🚨
// TODO: Replace Luxon's DateTime.local().toLocaleString(DateTime.DATE_HUGE) with Day.js equivalent
// const formattedDate = dayjs().format('MMMM D, YYYY');
export var PrintB2CButton = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var filteredFulfillmentObject = _a.filteredFulfillmentObject, _k = _a.orderDetailsData, billingAddress = _k.billingAddress, createDateTime = _k.createDateTime, _l = _k.deliveryCharge, deliveryCharge = _l === void 0 ? 0 : _l, _m = _k.grandTotalAmount, grandTotalAmount = _m === void 0 ? 0 : _m, _o = _k.orderNumber, orderNumber = _o === void 0 ? '' : _o, _p = _k.otherDiscountAmount, otherDiscountAmount = _p === void 0 ? 0 : _p, _q = _k.returnTotal, returnTotal = _q === void 0 ? 0 : _q, salesDate = _k.salesDate, _r = _k.shippingCharge, shippingCharge = _r === void 0 ? 0 : _r, subTotalAmount = _k.subTotalAmount, _s = _k.taxTotalAmount, taxTotalAmount = _s === void 0 ? 0 : _s, tenders = _k.tenders;
    var isConsumerApp = useExperienceContext().isConsumerApp;
    var formatDate = 'MMMM dd, yyyy';
    var componentRef = useRef(null);
    var handlePrint = useReactToPrint({
        content: function () { return componentRef.current; },
    });
    return (React.createElement("div", { className: "sui-flex" },
        !isConsumerApp && React.createElement(Link, { onClick: handlePrint }, "View Receipt"),
        React.createElement("div", { style: {
                border: '#CCC solid 1px',
            }, className: "sui-hidden print:sui-block sui-m-[10px]", ref: componentRef },
            React.createElement("img", { src: "https://assets.thdstatic.com/images/v1/THDLogoWithBroder.svg", alt: "HD-Logo", width: "60px", height: "60px" }),
            React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-[10px] sui-p-[10px]" },
                React.createElement(Typography, null,
                    React.createElement("span", { style: { fontWeight: 'bold' } }, "Date Ordered:"),
                    ' ',
                    DateTime.fromISO(salesDate || createDateTime).toFormat(formatDate)),
                React.createElement(Typography, null,
                    React.createElement("span", { style: { fontWeight: 'bold' } }, "Order Number:"),
                    ' ',
                    orderNumber),
                React.createElement(Typography, null,
                    React.createElement("span", { style: { fontWeight: 'bold' } }, "Order Total:"),
                    " $", grandTotalAmount === null || grandTotalAmount === void 0 ? void 0 :
                    grandTotalAmount.toLocaleString('en-US', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    }))), filteredFulfillmentObject === null || filteredFulfillmentObject === void 0 ? void 0 :
            filteredFulfillmentObject.map(function (item, key) {
                var _a;
                return (React.createElement(Fragment, { key: key },
                    React.createElement("p", { className: "sui-p-[10px]", style: {
                            fontWeight: 'bold',
                            borderTop: '#CCC solid 1px',
                            fontSize: '1.8rem',
                        } }, getDisplayHeader(item)),
                    React.createElement("div", { className: "sui-p-[10px]", style: { borderTop: '#CCC solid 1px' } },
                        React.createElement("p", { style: {
                                fontWeight: 'bold',
                                fontSize: '1.8rem',
                                marginBottom: '20px',
                            } }, "Product Information"),
                        React.createElement("div", { className: "sui-flex sui-w-[100%]" },
                            React.createElement("div", { style: { minWidth: '65%' } },
                                React.createElement("p", { style: { fontWeight: 'bold' } }, "Item")),
                            React.createElement("div", { style: { minWidth: '20%' } },
                                React.createElement("p", { style: { fontWeight: 'bold' } }, "Qty")),
                            React.createElement("div", { style: { textAlign: 'right', minWidth: '15%' } },
                                React.createElement("p", { style: { fontWeight: 'bold' } }, "Price"))), (_a = item === null || item === void 0 ? void 0 : item.lineItems) === null || _a === void 0 ? void 0 :
                        _a.map(function (lineItem, key2) {
                            var _a;
                            return (React.createElement("div", { style: { marginBottom: '10px' }, key: key2 },
                                React.createElement("div", { style: { display: 'flex', width: '100%' } },
                                    React.createElement("div", { style: { minWidth: '65%' } },
                                        React.createElement("p", { style: {
                                                maxWidth: '90%',
                                                wordBreak: 'break-word',
                                                whiteSpace: 'normal',
                                            } },
                                            (lineItem === null || lineItem === void 0 ? void 0 : lineItem.brandName) && (React.createElement("span", { style: { fontWeight: 'bold' } }, lineItem === null || lineItem === void 0 ? void 0 :
                                                lineItem.brandName,
                                                ' ')), lineItem === null || lineItem === void 0 ? void 0 :
                                            lineItem.description)),
                                    React.createElement("div", { style: { minWidth: '20%' } },
                                        React.createElement("p", null, getQuantityByStatus(lineItem))),
                                    React.createElement("div", { style: { textAlign: 'right', minWidth: '15%' } },
                                        React.createElement("p", null,
                                            "$", (_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.totalPrice) === null || _a === void 0 ? void 0 :
                                            _a.toLocaleString('en-US', {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })))),
                                (lineItem === null || lineItem === void 0 ? void 0 : lineItem.modelNumber) && (React.createElement("p", null,
                                    "Model #", lineItem === null || lineItem === void 0 ? void 0 :
                                    lineItem.modelNumber)),
                                (lineItem === null || lineItem === void 0 ? void 0 : lineItem.skuNumber) && (React.createElement("p", null,
                                    "Store SKU #", lineItem === null || lineItem === void 0 ? void 0 :
                                    lineItem.skuNumber))));
                        }))));
            }),
            React.createElement("p", { className: "sui-p-[10px]", style: {
                    fontWeight: 'bold',
                    borderTop: '#CCC solid 1px',
                    fontSize: '1.8rem',
                } }, "Payment Information"),
            React.createElement("div", { className: "sui-flex sui-justify-between sui-p-[10px]", style: {
                    borderTop: '#CCC solid 1px',
                } },
                React.createElement("div", { className: "sui-w-[60%]" },
                    React.createElement("div", null,
                        React.createElement("p", { style: { fontWeight: 'bold' } }, "Billing Address"),
                        React.createElement("p", null, (_b = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.name) === null || _b === void 0 ? void 0 :
                            _b.firstName,
                            ' ', (_c = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.name) === null || _c === void 0 ? void 0 :
                            _c.lastName),
                        React.createElement("p", null, (_d = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.postalDetails) === null || _d === void 0 ? void 0 : _d.addressLine1),
                        React.createElement("p", null, (_e = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.postalDetails) === null || _e === void 0 ? void 0 : _e.addressLine2),
                        React.createElement("p", null, (_f = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.postalDetails) === null || _f === void 0 ? void 0 :
                            _f.city,
                            ",",
                            ' ', (_g = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.postalDetails) === null || _g === void 0 ? void 0 :
                            _g.state,
                            ' ', (_h = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.postalDetails) === null || _h === void 0 ? void 0 :
                            _h.zipCode)),
                    React.createElement("div", null,
                        React.createElement("p", { style: { fontWeight: 'bold', marginTop: '10px' } }, "Payment Method"), tenders === null || tenders === void 0 ? void 0 :
                        tenders.map(function (tender, key) { return (React.createElement(Fragment, { key: key },
                            React.createElement("p", null, tender === null || tender === void 0 ? void 0 :
                                tender.type,
                                " | Ending in ", tender === null || tender === void 0 ? void 0 :
                                tender.value,
                                (tenders === null || tenders === void 0 ? void 0 : tenders.length) - 1 !== key && React.createElement("span", null, ", ")))); }))),
                React.createElement("div", { className: "sui-w-[40%] sui-pl-[40px] sui-flex sui-flex-col sui-gap-10" },
                    React.createElement("div", null,
                        React.createElement("p", { style: { fontWeight: 'bold' } }, "Payment Details"),
                        React.createElement("p", { className: "sui-flex sui-justify-between" },
                            "Subtotal",
                            ' ',
                            React.createElement("span", null,
                                "$", subTotalAmount === null || subTotalAmount === void 0 ? void 0 :
                                subTotalAmount.toLocaleString('en-US', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                }))),
                        otherDiscountAmount > 0 && (React.createElement("p", { className: "sui-flex sui-justify-between" },
                            "Discount",
                            ' ',
                            React.createElement("span", null,
                                "-$", otherDiscountAmount === null || otherDiscountAmount === void 0 ? void 0 :
                                otherDiscountAmount.toLocaleString('en-US', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                })))),
                        React.createElement("p", { className: "sui-flex sui-justify-between" },
                            "Delivery",
                            ' ',
                            shippingCharge + deliveryCharge > 0 ? (React.createElement("span", null,
                                "$", (_j = (shippingCharge + deliveryCharge)) === null || _j === void 0 ? void 0 :
                                _j.toLocaleString('en-US', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                }))) : (React.createElement("span", null, "FREE"))),
                        React.createElement("p", { className: "sui-flex sui-justify-between" },
                            "Sales Tax",
                            ' ',
                            React.createElement("span", null,
                                "$", taxTotalAmount === null || taxTotalAmount === void 0 ? void 0 :
                                taxTotalAmount.toLocaleString('en-US', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                })))),
                    React.createElement("div", null,
                        React.createElement("p", { className: "sui-flex sui-justify-between", style: {
                                fontSize: '1.8rem',
                            } },
                            "Order Total",
                            ' ',
                            React.createElement("span", null,
                                "$", grandTotalAmount === null || grandTotalAmount === void 0 ? void 0 :
                                grandTotalAmount.toLocaleString('en-US', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                }))),
                        returnTotal > 0 && (React.createElement("p", { className: "sui-flex sui-justify-between", style: {
                                fontSize: '1.8rem',
                            } },
                            "Refund Total",
                            ' ',
                            React.createElement("span", null,
                                "$", returnTotal === null || returnTotal === void 0 ? void 0 :
                                returnTotal.toLocaleString('en-US', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                }))))))))));
};
